export const testimonials = "/testimonials";
export const testimonialDetails = "/testimonials/";
export const updateTestimonial = "/testimonials/";
export const deleteTestimonial = "/testimonials/";
